import * as React from 'react'

const Arrows = ({
	size = 20,
	color = '#525252',
	activeColor = '#0053A0',
	inactiveColor,
	direction = 'none',
	strokeWidth = 1.5,
	...props
}) => {
	const upStroke = direction === 'asc' ? activeColor : (inactiveColor || color)
	const downStroke = direction === 'desc' ? activeColor : (inactiveColor || color)

	return (
		<svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} fill="none" viewBox="0 0 20 20" {...props}>
			<path
				stroke={upStroke}
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth={strokeWidth}
				d="M6 12V4M2.667 7.333 6 4l3.334 3.333"
			/>
			<path
				stroke={downStroke}
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth={strokeWidth}
				d="M13.667 8.417v8M10.333 13.083l3.334 3.334L17 13.083"
			/>
		</svg>
	)
}

export default Arrows
